/**
 * Sanitizes user-provided strings before persisting JSON payloads.
 * Removes CR/LF and other control characters, trims edges, and optionally
 * collapses repeated spaces.
 *
 * Double quotes (ASCII " and typographic variants) are replaced with single
 * quotes to prevent JSON corruption when a backend stores dsokSettings via
 * string concatenation without proper json_encode escaping.
 *
 * @param {string} value
 * @param {{ collapseWhitespace?: boolean }} [options]
 * @returns {string}
 */
export function sanitizeString(value, options = {}) {
  if (typeof value !== "string") return value;

  const { collapseWhitespace = false } = options;
  const cleaned = value
    .replace(/[\r\n]/g, "")
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g, "")
    // Normalize typographic/curly double quotes to single quotes
    .replace(/[\u201C\u201D\u201E\u201F\u2033\u2036\u275D\u275E]/g, "'")
    // Replace ASCII double quotes with single quotes to prevent JSON corruption
    .replace(/"/g, "'")
    .trim();

  if (!collapseWhitespace) return cleaned;
  return cleaned.replace(/[ \t]{2,}/g, " ");
}
